import SEO from "@/common/components/seo";
import usePrivacyPolicy from "../hooks/use-privacy-policy";

export default function PrivacyPolicyPage() {
	const { content } = usePrivacyPolicy();

	return (
		<div className="flex flex-col gap-8 px-4 py-6 md:gap-16 md:px-105 md:py-25">
			<SEO
				title="Privacy Policy - Reel Rewards"
				description="Read the Reel Rewards privacy policy and learn how we collect, use, and protect your information."
			/>
			<p className="web-heading-h2 text-center">Privacy Policy</p>
			<p className="web-body-b1 -mt-6 text-center text-gray-700">
				How we handle your data, clearly and transparently.
			</p>
			<div
				className="prose prose-lg max-w-none"
				dangerouslySetInnerHTML={{ __html: content }}
			/>
		</div>
	);
}
